import { Box } from '@mui/material';
import ETManagerWidget from '@src/App/Components/_UnderConstruction/Widgets/ETManagerWidget';
import TeamOverviewWidget from '@src/App/Components/_UnderConstruction/Widgets/TeamOverviewWidget';
import React from 'react';

export default function ManagerDashboardSection() {
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 5 }}>
            <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
                <TeamOverviewWidget />
            </Box>
            <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
                <ETManagerWidget />
            </Box>
        </Box>
    );
}
